// src/pages/sow-template/AddSectionModal.jsx
//
// Replaces the old window.prompt("Section title?") -- a raw browser
// dialog doesn't match the rest of the app.

import { useState } from "react";
import PropTypes from "prop-types";
import { Button, FormField, Input, Modal, useDiscardConfirm } from "../../shared/ui";

export default function AddSectionModal({ open, onClose, onAdd }) {
  const [title, setTitle] = useState("");
  const [dirty, setDirty] = useState(false);

  function handleClose() {
    setTitle("");
    setDirty(false);
    onClose();
  }

  const { requestClose, confirmDialog } = useDiscardConfirm(dirty, handleClose);

  const handleAdd = () => {
    if (!title.trim()) return;
    onAdd(title.trim());
    setTitle("");
    setDirty(false);
  };

  return (
    <>
      <Modal
        open={open}
        title="Add Section"
        onClose={requestClose}
        footer={
          <>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={handleAdd} disabled={!title.trim()}>
              Add Section
            </Button>
          </>
        }
      >
        <FormField label="Section Title" required helperText="e.g. 4. Scope Exclusions">
          <Input
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setDirty(true);
            }}
            onKeyDown={(e) => e.key === "Enter" && handleAdd()}
            autoFocus
          />
        </FormField>
      </Modal>
      {confirmDialog}
    </>
  );
}

AddSectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};
